import React from 'react';
import ClassAssembly  from 'views/ClassAssembly3B';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;